import styled from 'styled-components';
const CollapsableSidebarFadingContent = styled.div.withConfig({
  displayName: "CollapsableSidebarFadingContent",
  componentId: "n0tkym-0"
})(["opacity:", ";transition:opacity 100ms;"], ({
  hide
}) => hide ? 0 : 1);
export default CollapsableSidebarFadingContent;